import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable, map } from 'rxjs';
import { Router } from '@angular/router';
import { EntraService } from '../services/entra.service';

/**
 * AdminGuard is an Angular route guard that checks whether the user is an admin.
 * 
 * The guard checks the isAdmin signal from the EntraService to determine if the user
 * has admin privileges. If the user is an admin, they are granted access to the route.
 * If not, they are redirected to the forms landing page.
 */
@Injectable({
  providedIn: 'root',
})
export class AdminGuard implements CanActivate {

  constructor(
    private router: Router,
    private entraService: EntraService
  ) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    // Check if user is logged in and is an admin
    const isLoggedIn = this.entraService.userIsLoggedIn();
    const isAdmin = this.entraService.isAdmin();

    if (isLoggedIn && isAdmin) {
      return true; // User is logged in and is an admin
    } else {
      // Redirect to forms landing page if not admin
      this.router.navigate(['/forms']);
      return false; // Prevent route access
    }
  }
} 